<template>
	<div class="form-group c-input-upload-multiple">
		<label v-if="label" class="form__label" :for="slug">{{ label }}</label>
		<div class="c-input-upload__inner">
			<div class="c-input-upload-multiple__images">
				<div
					class="c-input-upload-multiple__image"
					v-for="(img, index) in previewImages"
					:key="index"
				>
					<img :src="img" />
					<span
						type="button"
						class="c-input-upload-multiple__remove"
						@click="removeImage(index)"
					>
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M8 8L16 16M16 8L8 16"
								stroke="currentColor"
								stroke-width="2"
								stroke-linecap="round"
							/>
						</svg>
					</span>
				</div>
			</div>

			<input
				:class="[{ 'form-control': noStyle === false }]"
				:id="slug"
				type="file"
				multiple
				:disabled="files.length >= maxFiles"
				@change="onChange"
			/>
			<small
				v-if="files.length >= maxFiles"
				class="c-input-upload-multiple__limit"
			>
				Max {{ maxFiles }} images allowed.
			</small>
		</div>
		<InputError v-if="hasError" :message="errorMessage"></InputError>
		<InputDescription
			v-if="description"
			:message="description"
		></InputDescription>
	</div>
</template>

<script>
import InputError from './input-error';
import InputDescription from './input-description';
import slugify from '@swipekit/lib/slugify.js';

export default {
	name: 'InputUploadMultiple',

	components: {
		InputError,
		InputDescription,
	},

	data: function () {
		return {
			previewImages: [],
			files: [],
			maxFiles: 5,
		};
	},

	props: {
		label: {
			type: String,
			default: '',
		},
		validation: {},
		value: {
			type: Array,
			default: () => [],
		},
		placeholder: {
			type: String,
			default: '',
		},
		noStyle: {
			type: Boolean,
			default: false,
		},
		description: {
			type: String,
			default: '',
		},
		hasError: {
			type: Boolean,
			default: false,
		},
		errorMessage: {},
	},

	watch: {
		value(newVal) {
			if (!newVal || !Array.isArray(newVal)) return;
			this.files = newVal;
		},
	},

	computed: {
		slug: function () {
			return slugify(this.label || `input_${Math.floor(Math.random() * 100)}`);
		},
	},

	methods: {
		onChange(e) {
			const newFiles = Array.from(e.target.files);

			// Prevent exceeding max files
			if (this.files.length + newFiles.length > this.maxFiles) {
				this.$store.dispatch('app/sendNotification', {
					message: `You can upload a maximum of ${this.maxFiles} images.`,
				});
				return;
			}

			newFiles.forEach((file) => {
				this.files.push(file);
				const reader = new FileReader();
				reader.onload = (ee) => {
					this.previewImages.push(ee.target.result);
				};
				reader.readAsDataURL(file);
			});

			this.$emit('input', this.files);
		},

		removeImage(index) {
			this.files.splice(index, 1);
			this.previewImages.splice(index, 1);
			this.$emit('input', this.files);
		},
	},

	mounted() {
		if (this.value && Array.isArray(this.value)) {
			this.files = this.value;
		}
	},
};
</script>

<style lang="scss">
.c-input-upload-multiple {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding-bottom: var(--margin-lg);

	&__images {
		display: flex;
		flex-wrap: wrap;
		gap: var(--margin);
		margin-bottom: var(--margin);
	}

	&__image {
		position: relative;
		width: 64px;
		min-width: 64px;
		height: auto;
		background-color: var(--color-bg-4);

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			object-position: center center;
			border-radius: var(--border-radius-sm);
		}
	}

	&__remove {
		position: absolute;
		z-index: 9;
		top: -8px;
		right: -8px;
		background: rgba(0, 0, 0, 0.6);
		color: #fff;
		border: none;
		border-radius: 50%;
		width: 16px;
		height: 16px;
		cursor: pointer;
		text-align: center;
		padding: 0;

		svg {
			width: 100%;
			height: 100%;
		}

		&:hover {
			background: rgba(0, 0, 0, 0.8);
		}
	}

	&__limit {
		color: var(--color-danger, red);
		font-size: 0.85rem;
		margin-top: 4px;
	}

	&__inner {
		display: flex;
		flex-direction: column;

		.form-control {
			width: 100%;
			margin-top: var(--margin-sm);
			padding: var(--margin-sm);
		}
	}
}
</style>
